<template>
  <v-dialog
      v-model="dialog"
      hide-overlay
      persistent
      content-class="sajilo-loader"
      width="100vw"
    >
      <v-card
        class="primary-loader"
        dark
      >
        <v-card-text class="py-0 px-0">
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'loading',
    data:()=>({
        dialog: false,
    }),
    created () {
        this.$bus.on('loading-toggle', () => {
            this.dialog = !this.dialog
        })
    },
    watch: {
      dialog (val) {
        if (!val) return

        setTimeout(() => (this.dialog = false), 2000)
      },
    },
}
</script>

<style>

</style>